import{EAlertIntent as t}from"../../utils/constants.js";const s={intent:t.info,message:""};export{s as DEFAULT_ALERT_CONTENT};
